import {
  createProjectFormSchema,
  type CreateProjectFormValues,
} from '@/domains/dashboard/components/create-organization-project.schema';
import { DEFAULT_CREATE_PROJECT_PRODUCT } from '@/domains/dashboard/components/project-product-selector';

export const createProjectOnboardingSchema = createProjectFormSchema;

export type ICreateProjectOnboardingFormValues = CreateProjectFormValues;

export const createProjectOnboardingInitialValues: ICreateProjectOnboardingFormValues = {
  projectName: '',
  product: DEFAULT_CREATE_PROJECT_PRODUCT,
};
